import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { errorMsg } from 'utils';
import { url } from 'utils/url';

export const MEDIA_CALENDAR_SUCCESS = createAction('MEDIA_CALENDAR_SUCCESS');

export const MEDIA_CALENDAR_LOADING = createAction('MEDIA_CALENDAR_LOADING');

export const fetchMediaCalendar = ({
  siteId,
  start,
  end,
  screenId,
  categoryId,
}) => {
  return async (dispatch) => {
    try {
      dispatch(MEDIA_CALENDAR_LOADING(true));

      const params = {
        siteId,
        start,
        end,
      };

      if (screenId) {
        params.screenId = screenId;
      }

      if (categoryId) {
        params.categoryId = categoryId;
      }

      const response = await axios.get(`${url}/media/calendar`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      dispatch(MEDIA_CALENDAR_SUCCESS(response.data));

      return response.data;
    } catch (error) {
      toastr.error('', errorMsg(dispatch, error));
      throw error;
    } finally {
      dispatch(MEDIA_CALENDAR_LOADING(false));
    }
  };
};
